/// <reference types="fhir" />

import { Component, Input, OnInit } from "@angular/core";
import {
  Topic,
  TopicItem,
  IRelevantSupportActionModalNavParams,
  Score,
  IScoreResult
} from "../../../../app/models/types";
import { ModalController } from "ionic-angular";
import { OptionObject } from "@zitelab/ionic-fhir-questionnaires";
import { DiaprofilPatient } from "../../../../app/models/diaprofil-patient";
import { RelevantSupportActionsModal } from "../../../../modals/relevant-support-actions.modal/relevant-support-actions.modal";
import { DatePipe } from "@angular/common";
import { DiaprofilProTask } from "../../../../app/models/diaprofil-pro-task";
import {
  EventLoggingService,
  LogEventId
} from "../../../../app/services/event-logging.service";

@Component({
  selector: "topic-card-key-item-section",
  templateUrl: "./topic-card-key-item-section.component.html"
})
export class TopicCardKeyItemSection implements OnInit {
  @Input() topic: Topic;
  @Input() task: DiaprofilProTask;
  @Input() keyItems: TopicItem[];
  @Input() otherItems: TopicItem[];
  @Input()
  displaySettings: {
    enableOtherHighlightedAnswers: boolean;
    showNoteInput: boolean;
    enableTrendDisplay: boolean;
    colorBlindMode: boolean;
  };
  @Input() patient: DiaprofilPatient;
  who5ScoreInfo: IScoreResult = {
    scoreId: null,
    title: null,
    score: null,
    color: null,
    min: null,
    max: null
  };
  mdi2ScoreInfo: IScoreResult = {
    scoreId: null,
    title: null,
    score: null,
    color: null,
    min: null,
    max: null
  };
  constructor(
    private modalCtrl: ModalController,
    private datePipe: DatePipe,
    private eventLogging: EventLoggingService
  ) {}

  ngOnInit() {
    if (this.topic.id === "MENTAL_HEALTH") {
      this.who5ScoreInfo = {
        ...this.task.who5,
        scoreId: "WHO-5",
        title: "Trivselsscore (WHO-5)",
        min: 0,
        max: 100
      };
      this.mdi2ScoreInfo = {
        ...this.task.mdi2,
        scoreId: "MDI-2",
        title: "MDI-2",
        min: 0,
        max: 10
      };
    }
  }

  cleanSymptomsLabel(label) {
    label = label.replace(
      "I de sidste 4 uger har jeg været meget generet af ",
      ""
    );
    label = label.replace("?", "");
    label = label.charAt(0).toUpperCase() + label.slice(1);
    return label;
  }

  openRelevantSupportActionsModal(
    props: {
      items: TopicItem[];
      scoreIds: Score[];
      scoreResults: { [key in Score]: IScoreResult };
      title: string;
    } = {
      items: [],
      scoreIds: [],
      scoreResults: { "WHO-5": null, "MDI-2": null },
      title: null
    }
  ) {
    this.eventLogging.saveEvent({
      event_id: LogEventId.OPEN_SUPPORT_ACTION_MODAL,
      event_src_location: "TopicCard",
      parent_task_uuid: this.task.task.id,
      qnr_response_uuid: this.task.response.id,
      patient_fhir_id: this.patient.fhirId,
      patient_full_name: this.patient.fullName,
      additional_info: {
        topicName: this.topic.id,
        items: props.items.map(x => x.config.name).join()
      }
    });
    props.scoreIds = props.scoreIds === undefined ? [] : props.scoreIds;
    props.scoreResults =
      props.scoreResults === undefined
        ? { "WHO-5": null, "MDI-2": null }
        : props.scoreResults;
    const data: IRelevantSupportActionModalNavParams = {
      supportFor: {
        proItems: props.items,
        patientWishes: [],
        consultationTopics: [],
        scoreIds: props.scoreIds
      },
      patient: this.patient,
      modalType: "PRO_ITEM",
      modalTitle: props.title,
      scoreResults: props.scoreResults
    };
    const modal = this.modalCtrl.create(RelevantSupportActionsModal, data, {
      cssClass: "large-modal",
      enableBackdropDismiss: false
    });
    modal.present();
  }

  createTrendTooltip(item: TopicItem) {
    if (item.trendInfo.prev.responseId === null) {
      return "Intet tidligere svar";
    }
    const date = this.datePipe.transform(
      item.trendInfo.prev.date,
      "dd-MM-yyyy"
    );
    const optionObj = item.trendInfo.prev.answerInfo.optionObj as OptionObject;
    return `${date}: ${optionObj.display}`;
  }

  getFreeTextItem(freeTextItemName: string): TopicItem {
    return this.otherItems.find(elem => elem.config.name === freeTextItemName);
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard.page/topic-card.component/topic-card-key-item-section.component/topic-card-key-item-section.component.ts